var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "view",
    staticClass: "utf_payload_view",
    on: {
      "mouseenter": _vm.mouseEnter,
      "mouseleave": _vm.mouseLeave
    }
  }, [_c('p', {
    staticClass: "icon"
  }, [_c('fa', {
    attrs: {
      "icon": "font"
    }
  })], 1), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isText,
      expression: "isText"
    }],
    ref: "text",
    staticClass: "hover_text"
  }, [_vm._v(_vm._s(_vm.text))])]);
}
var staticRenderFns = []

export { render, staticRenderFns }